import { render, staticRenderFns } from "./InsuranceCompaniesEl.vue?vue&type=template&id=50a0f839&scoped=true"
import script from "./InsuranceCompaniesEl.vue?vue&type=script&lang=js"
export * from "./InsuranceCompaniesEl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a0f839",
  null
  
)

export default component.exports